import React from "react";
import { CancellationOfferDefinition } from "@functions/plans/info/cancellationOffers";
import { CancelPlanOffersModal } from "./CancelPlanOffersModal";
import { CancelPlanBasicDowngradeModal } from "./CancelPlanBasicDowngradeModal";
import { CancelPlanExternalLinkModal } from "./CancelPlanExternalLinkModal";
import { frequencies } from "../../../../../clientServices/workspaceFeaturesCredits";

type CancelPlanOfferRouterProps = {
    isOpen: boolean;
    onClose: () => void;
    onCancel: () => void;
    offer: CancellationOfferDefinition;
    onAcceptCreditsOffer: (offerId: string) => Promise<any>;
    onAcceptDowngrade: (basicDowngradeFrequency: (typeof frequencies)[number]) => void;
    pricePerCredit: number;
    currentPlan: string;
};

export function CancelPlanOfferRouter({
    isOpen,
    onClose,
    onCancel,
    offer,
    onAcceptCreditsOffer,
    onAcceptDowngrade,
    pricePerCredit,
    currentPlan
}: CancelPlanOfferRouterProps) {
    switch (offer.variant) {
        case "credits":
            return (
                <CancelPlanOffersModal
                    isOpen={isOpen}
                    onClose={onClose}
                    onCancel={onCancel}
                    onAcceptOffer={() => onAcceptCreditsOffer(offer.id)}
                    pricePerCredit={pricePerCredit}
                    offer={offer}
                />
            );
        case "downgrade":
            return (
                <CancelPlanBasicDowngradeModal
                    isOpen={isOpen}
                    onClose={onClose}
                    onCancel={onCancel}
                    onAcceptBasicPlanDowngrade={onAcceptDowngrade}
                    currentPlan={currentPlan}
                    targetPlan={offer.variantConfig.targetPlan as "basic" | "core"}
                />
            );
        case "externalLink":
            return (
                <CancelPlanExternalLinkModal
                    isOpen={isOpen}
                    onClose={onClose}
                    onCancel={onCancel}
                    offer={offer}
                />
            );
        default:
            return null;
    }
}
